<script setup lang="ts">
import {
  TypographyTitle,
  TypographyParagraph,
  TypographyText,
} from 'ant-design-vue';

interface Props {
  type?: 'title' | 'text' | 'para';
  level?: 1 | 2 | 3 | 4 | 5;
  strong?: boolean;
  ellipsis?: boolean;
  content?: string;
}
const props = withDefaults(defineProps<Props>(), {
  type: 'title',
  level: 3,
  strong: false,
  ellipsis: false,
  content: '',
});

const TypoComp =
  props.type === 'title'
    ? TypographyTitle
    : props.type === 'para'
      ? TypographyParagraph
      : TypographyText;

const getEllipsis = props.ellipsis && { tooltip: props.content };
</script>

<template>
  <TypoComp
    :level="props.level"
    :strong="props.strong"
    :ellipsis="getEllipsis"
    :content="content"
  >
    <slot></slot>
  </TypoComp>
</template>

<style lang="scss" scoped></style>
